import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Patient } from '@pxl/models/common';
import { PatientService } from '@pxl/models/contracts';

export const patientResolver: ResolveFn<Patient> = async (route: ActivatedRouteSnapshot) => {
    const patientId = route.params['patientId'];
    const patient = await inject(PatientService).getPatientWithPatientId(patientId);
    if (!patient) throw new Error('patient not found');
    return patient;
};
